import goto from "./index";
import getStore from "@utils/redux/store";
import {
  hasPromoCode,
  hasVipPromoCode,
  isFastForwardEligible,
  isAddonStoreEligible,
  isNoomSummitEligible,
} from "@utils/userSegment/features";
import { isEnLanguage, isInApp, isUS } from "src/utils/userSegment";
import { updateForwardedParams } from "src/utils/urlParams";
import { CHECK_EMAIL_REMINDER_PARAM } from "src/components/collapsible-header/CollapsibleHeader";

// This navigates outside of the Noom Premium context
export default {
  async navigateFromNoomPremium(showEmailReminder = true) {
    const { purchasedNoomPremium } = getStore().getState();

    if (!hasPromoCode() && isFastForwardEligible()) {
      goto.fastForwardTrial({
        showEmailReminder:
          purchasedNoomPremium && showEmailReminder ? "noomPremium" : null,
      });
      return;
    }

    if (isUS() && isEnLanguage()) {
      await isNoomSummitEligible.load();
    }

    if (!hasVipPromoCode() && isNoomSummitEligible()) {
      updateForwardedParams({
        [CHECK_EMAIL_REMINDER_PARAM]:
          purchasedNoomPremium && showEmailReminder ? "noomPremium" : null,
      });
      goto.layer("noom-summit");
      return;
    }

    if (!hasVipPromoCode() && isAddonStoreEligible()) {
      goto.addOns({});
      return;
    }

    if (isInApp()) {
      goto.nativePurchaseComplete();
      return;
    }

    goto.enrollment({
      showEmailReminder: purchasedNoomPremium ? "noomPremium" : null,
    });
  },
};
